import { PATHS, PATHS_PARAMS } from "constants/PATHS";
import { getResource } from "services";

export function getTermsAndConditions(lang, onSuccess, onFail) {
	const path = PATHS(PATHS_PARAMS.getTermsAndConditions, lang, { lang: lang });
	getResource(path, onSuccess, onFail);
}
